import missionBg from '../../assets/DSCN2582.JPG';
import { Link } from 'react-router-dom';

export default function OurMission() {
  return (
    <section className="section ourmission-container relative w-full h-screen overflow-hidden">
      {/* Transparent Background Image */}
      <img
        src={missionBg}
        alt="nonprofit building"
        className="mission-bg absolute inset-0 w-full h-full object-cover opacity-90 z-0"
      />

      {/* Text Content */}
      <div className="relative bg-gray-100 rounded-2xl">
        <h1 className="ourmission-title text-sky-950">OUR&nbsp;MISSION</h1>
        <div className="ourmission-text">
          <p className='mb-10'>
            At the Nisa and Sabir Foundation, our mission is clear: We are dedicated to <span>empowering</span> underprivileged <span>communities</span> through skill-building programs and access to medical care.
            <br />
            <br />
          </p>
          <Link
            to="/donate"
            className="om-button blue-bg text-gray-100 font-bold text-lg py-5 px-10 rounded-full transition-all duration-300 shadow-lg transform hover:scale-105 focus:ring focus:ring-gray-500"
          >
            Donate Now
          </Link>
        </div>
      </div>
    </section>
  );
}
